import React, { useState, useEffect } from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import api from '../../services/api';

const PayrollCompanySection = ({ formData, handleChange }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await api.get('/api/companies?active_only=true');
        setCompanies(response.data);
      } catch (error) {
        console.error('Failed to fetch companies:', error);
        // Fallback to default companies
        setCompanies([
          { code: 'MSBR', name: 'MSBR' },
          { code: 'SE', name: 'SE' },
          { code: 'SG', name: 'SG' },
          { code: 'Heroes', name: 'Heroes' },
          { code: 'Cash/Cheque', name: 'Cash/Cheque' },
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanies();
  }, []);

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Payment Method</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label>Payment Through</Label>
          <Select 
            value={formData.payment_method || ''} 
            onValueChange={(value) => handleChange('payment_method', value)}
            disabled={loading}
          >
            <SelectTrigger data-testid="payment-method-select">
              <SelectValue placeholder="Select payment method" />
            </SelectTrigger>
            <SelectContent>
              {companies.map((company) => (
                <SelectItem key={company.code} value={company.code}>
                  {company.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-gray-500 mt-1">
            Company for salary payment and payroll reporting
          </p>
        </div>
      </div>
    </div>
  );
};

export default PayrollCompanySection;
